/*
 * Operator webapp routes
 */
export const ROUTE_DASHBOARD = "/";
export const ROUTE_DASHBOARD_LABEL = "dashboard.title";
export const ROUTE_BENEFICIARY_FILE = (beneficiaryId) =>
  `/beneficiary/${beneficiaryId}`;
export const ROUTE_BENEFICIARY_FILE_LABEL = "beneficiaryFile.title";
export const ROUTE_BENEFICIARY_SERVICES = (beneficiaryId) =>
  `/beneficiary/${beneficiaryId}/services`;
export const ROUTE_BENEFICIARY_SERVICES_LABEL = "beneficiaryServices.title";
export const ROUTE_BENEFICIARY_FILE_STATUS = (beneficiaryId) =>
  `/beneficiary/${beneficiaryId}/services/status`;
export const ROUTE_BENEFICIARY_FILE_STATUS_LABEL =
  "beneficiaryFileStatus.title";

export const ROUTE_LOGIN = "/login";

// Deprecated
export const ROUTE_PLUGIN = "/plugin";
export const ROUTE_MAINFORM = "/mainform";
